import React, {Component, PropTypes} from 'react';
import classNames from 'classnames';

export default class HelpText extends Component {
    static propTypes = {
        children: PropTypes.node.isRequired,
        className: PropTypes.string,
    };

    shouldComponentUpdate(nextProps) {
        return nextProps.children !== this.props.children;
    }

    render() {
        return (
            <div className={classNames('cielo24-vwrap-form-help-text', this.props.className)}>
                {this.props.children}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/components/forms/help-text.js